import { defineStore } from "pinia";
import type { LocationQuery } from "vue-router";

export const useAppStore = defineStore("app", {
  state: () => ({
    //
    loading: false,
    token: "",
    owner: "",
    contact: "",
  }),
  actions: {
    setFromQuery(query: LocationQuery) {
      this.token = `${query.token || ""}`;
      this.owner = `${query.owner || ""}`;
      this.contact = `${query.mobile || ""}`;
    },
    onLoading(){
      this.loading = true;
    },
    offLoading(){
      this.loading = false;
    }
  },
});
